import { useEffect, useState } from "react";

/** True only after `active` has stayed true for `delayMs` — stops fast loads
 * (cached reads) from flashing a heavy loader. Resets the moment active drops. */
export function useDelayedFlag(active: boolean, delayMs = 400): boolean {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return;
    }
    const id = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(id);
  }, [active, delayMs]);
  return shown;
}
